import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CurrencyFormatDirective } from "./currency-format.directive";
import { CurrencyInputFormatDirective } from "./currency-input-format.directive";
import { PhoneNumberDirective } from "./phone-number.directive";
import { FormErrorListComponent } from "./form-error-list.component";
import { AutofocusDirective } from "./auto-focus.directive";
import { OptionsScrollDirective } from "./options-scroll.directive";
import { TrimValueDirective } from "./trim-value.directive";
import { LazyContentDirective } from "./lazy-content.directive";
import { FullScreenDirective } from "./full-screen.directive";
import { ShortcutsDirective } from "./shortcuts.directive";
import { UppercaseDirective } from "./uppercase.directive";
import { MatSelectRemoveAriaOwnsDirective } from "./mat-select.directive";
import { PreventMultipleClicksDirective } from "./prevent-multiple-clicks.directive";
import { ApplyOnlyNumbersDirective } from "./only-numbers.directive";
import { IsDeveloperDirective } from "./is-developer.directive";
import { IsUserDirective } from "./is-user.directive";
import { IsRoleDirective } from "./is-role.directive";
import { DetectAutofillDirective } from "./detect-autofill.directive";

@NgModule({
  declarations: [
    CurrencyFormatDirective,
    CurrencyInputFormatDirective,
    PhoneNumberDirective,
    FormErrorListComponent,
    AutofocusDirective,
    OptionsScrollDirective,
    TrimValueDirective,
    LazyContentDirective,
    FullScreenDirective,
    ShortcutsDirective,
    UppercaseDirective,
    MatSelectRemoveAriaOwnsDirective,
    PreventMultipleClicksDirective,
    ApplyOnlyNumbersDirective,
    IsDeveloperDirective,
    IsUserDirective,
    IsRoleDirective,
    DetectAutofillDirective,
  ],
  imports: [CommonModule],
  exports: [
    CurrencyFormatDirective,
    CurrencyInputFormatDirective,
    PhoneNumberDirective,
    FormErrorListComponent,
    AutofocusDirective,
    OptionsScrollDirective,
    TrimValueDirective,
    LazyContentDirective,
    FullScreenDirective,
    ShortcutsDirective,
    MatSelectRemoveAriaOwnsDirective,
    UppercaseDirective,
    PreventMultipleClicksDirective,
    ApplyOnlyNumbersDirective,
    IsDeveloperDirective,
    IsUserDirective,
    IsRoleDirective,
    DetectAutofillDirective,
  ],
})
export class DirectiveModule {}
